import React from "react";
import { Navigate } from "react-router-dom";
import { usePermissions } from "../../../../utils/permissions";

const destinos = [
  { to: "/dashboard/plantillas/convocatoria-plantillas", permission: "convocatoria_plantillas.listar" },
];

export default function PlantillasView() {
  const { hasPermission } = usePermissions();
  const destino = destinos.find((item) => hasPermission(item.permission))?.to;

  if (!destino) {
    return <Navigate to="/dashboard/view_dashboard" replace />;
  }

  return <Navigate to={destino} replace />;
}
